export default __webpack_public_path__ + "static/media/7minfitness@3x.2b5b0fa1.jpg";